import { useQuery } from '@tanstack/react-query';
import { fetchProduct } from '../services/products';
import { productKeys } from '@/features/products/hooks/useProductsQuery';

export const useProductQuery = (id?: string) =>
    useQuery({
        queryKey: productKeys.detail(id ?? ''),
        queryFn: () => fetchProduct(id as string),
        enabled: Boolean(id),
    });
